
import React from 'react';
import { 
  WrapperCardGrid, 
  SkeletonLoader, 
  makeArrayFromLength,
  PaddingTopBottom40,
  Container 
} from "oolib";
import { MediaItem } from './MediaItem';

const MediaGrid = ({
  observerRef,
  isFetchingNextPage,
  status, 
  data, 
  onItemClick 
}) => {

  const renderLibrary = () => {
    if (status === "loading") {
      return makeArrayFromLength(40).map((_, i) => (
        <SkeletonLoader key={i} style={{ height: "10rem" }} />
      ));
    }

    if (status === "error") {
      return <div>Error loading media content</div>;
    }

    return data?.map((item, index) => (
      <div key={`${item.id}-${index}`} ref={index === data.length - 1 ? observerRef : null}>
        <MediaItem
          item={item}
          index={index}
          onItemClick={onItemClick}
        />
      </div>
    ));
  };

  return (
    <Container style={{ flexGrow: 1 }}>
      <PaddingTopBottom40>
        <WrapperCardGrid minWidth="15rem">
          {renderLibrary()}
          { isFetchingNextPage && makeArrayFromLength(40).map((_, i) => (
              <SkeletonLoader key={i} style={{ height: "10rem" }} />
            ))
          }
        </WrapperCardGrid>
      </PaddingTopBottom40>
    </Container>
  );
};

export default MediaGrid;